// Class: motion.easing._Expo.ExpoEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var ExpoEaseIn = function() {
}

// Meta

ExpoEaseIn.__name__ = ["motion","easing","_Expo","ExpoEaseIn"];
ExpoEaseIn.__isInterface__ = false;
ExpoEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
ExpoEaseIn.prototype = {
	calculate: function(k) {
		if(k == 0) {
			return 0;
		} else {
			return Math.exp(6.931471805599453 * (k - 1));
		}
	},
	ease: function(t,b,c,d) {
		if(t == 0) {
			return b;
		} else {
			return c * Math.exp(6.931471805599453 * (t / d - 1)) + b;
		}
	}
};
ExpoEaseIn.prototype.__class__ = ExpoEaseIn.prototype.constructor = $hxClasses["motion.easing._Expo.ExpoEaseIn"] = ExpoEaseIn;

// Init



// Statics




// Export

exports.default = ExpoEaseIn;